<p-panel header="{{ config.title }}">
    <div style="min-height: 26rem" class="panelContent">
        <div class="grid mb-0 panel-header-wrapper">
            <app-select-all-toggle *ngIf="config.showSelectAll" [allSelected]="parentSelection"
                [disabled]="!config.enableSelectAll && pagedData.data.length > 0"
                (selectionChange)="selectAllToggle($event)"></app-select-all-toggle>
            <app-filters *ngIf="config.filterConfigs && config.filterConfigs.length > 0"
                [filterConfig]="config.filterConfigs || []" [standardFilterCount]="config.standardFilterCount"
                (filterChange)="onFiltersChange($event)"
                (filterEventHub)="onFilterEventHubInitialized($event)"
                (clearAllClicked)="onClearAllFilters()"></app-filters>
            <div *ngIf="config.enableShowAllToggle"
                class="col justify-content-center align-items-center additional-items-content">
                <span class="additional-items">
                    <p-checkbox class="p-0 pr-2" name="showAllToggle" [binary]="true" [(ngModel)]="isShowAllSelected"
                        (onChange)="onShowAllChange()">
                    </p-checkbox>
                    <app-label [labelText]="config.showAllLabel || 'Show All'"></app-label>
                    <i class="fa fa-info-circle ml-2 info-icon-color"
                        *ngIf="config.showAllTooltip && config.showAllTooltip.length > 0"
                        pTooltip="{{ config.showAllTooltip }}">
                    </i>
                </span>
            </div>
            <div class="col align-items-center sortBy" *ngIf="config.sortOptions && config.sortOptions.length > 0">
                <app-sort-menu [sortOptions]="config.sortOptions || []"
                    (sortChange)="onSortChange($event)"></app-sort-menu>
            </div>
            <div class="col align-items-center panelToggler"
                *ngIf="config.enableToggling || config.enableExport || config.enableViewModes">
                <bpt-menu-button [model]="menuItems" [label]="''" [icon]="'icon-dots-vertical'" [compact]="true"
                    [stroked]="false" [disabled]="false">
                </bpt-menu-button>
            </div>
        </div>
        <div class="panel-list-content" *ngIf="pagedData.data.length > 0 && !showLoader">
            <div *ngFor="let item of pagedData.data; index as i" class="grid">
                <div *ngIf="config.enableSelection" class="col select-cards">
                    <p-checkbox name="panelCardSelection" [value]="item" [ngModel]="getSelecteditems(item,i)"
                        [binary]="true" [disabled]="isItemDisabled(item)"
                        (onChange)="panelCardItemSelectionChange(item, $event, i)"
                        pTooltip="{{ getToolTipForDisabledCheckBox(item) }}"></p-checkbox>
                </div>
                <div [ngClass]="{
            'panel-card-selection': config.enableSelection,
            'panel-card-no-selection': !config.enableSelection
          }">
                    <app-panel-card [ngClass]="{'highlight-panel' : i == activePanelCard}" [data]="item"
                        [isCardToggleable]="config.enableToggling" (click)="onPanelCardClick(item,i)">
                        <ng-template #template1 let-data="data">
                            <ng-container [ngTemplateOutlet]="headerTemplate"
                                [ngTemplateOutletContext]="{ dataVar: item, currentView: currentView }">
                            </ng-container>
                        </ng-template>
                        <ng-template #template let-data="data">
                            <ng-container [ngTemplateOutlet]="contentTemplate"
                                [ngTemplateOutletContext]="{ dataVar: item, currentView: currentView }">
                            </ng-container>
                        </ng-template>
                    </app-panel-card>
                </div>
            </div>
        </div>
        <div class="panel-list-content" style="padding: 100px 0;"
            *ngIf="pagedData.data.length == 0 && !showLoader">
            <app-empty-results></app-empty-results>
        </div>
        <div class="panel-footer-wrapper" *ngIf="config.paginationConfig.enabled && pagedData.data.length > 0">
            <app-paginator [totalRecords]="pagedData.totalRecords" [currentPage]="currentPage"
                [pageSize]="pagedData.pageSize"
                [pageSizeOptions]="config.paginationConfig.availablePageSizes" (pageChange)="onPageChange($event)">
            </app-paginator>
        </div>
    </div>
</p-panel>
